import { TableColumn, TableConfig } from "../../../@shared/models/table.models";

export const DOCUMENTS_TABLE_COLUMNS: TableColumn[] = [
    {
        field: "name",
        header: "Document Name",
        type: "custom",
        template: "documentNameTemplate",
        width: "18%"
    },
    {
        field: "project",
        header: "Project",
        type: "custom",
        template: "projectTemplate",
        width: "11%"
    },
    {
        field: "linkedDocType",
        header: "Document Type",
        type: "custom",
        template: "documentTypeTemplate",
        width: "11%"
    },
    {
        field: "assignees",
        header: "Shared with",
        type: "custom",
        template: "assigneesTemplate",
        width: "9%"
    },
    {
        field: "updatedAt",
        header: "Last Edited",
        type: "custom",
        template: "dateUpdatedTemplate",
        width: "12%"
    },
    {
        field: "dueDate",
        header: "Due Date",
        type: "custom",
        template: "dueDateTemplate",
        width: "9%"
    },
    {
        field: "documentStatus",
        header: "Status",
        type: "custom",
        template: "statusTemplate",
        width: "9%"
    },
    {
        field: "upcomingMilestone",
        header: "Upcoming Milestone",
        type: "custom",
        template: "upcomingMilestoneTemplate",
        width: "13%"
    },
    {
        field: "actions",
        header: "Actions",
        type: "custom",
        template: "actionsTemplate",
        width: "8%"
    }
];

export const DOCUMENTS_TABLE_CONFIG: TableConfig = {
    selectable: false,
    paginator: true,
    rows: 20,
    rowsPerPageOptions: [20, 30, 40],
    scrollable: true,
    scrollHeight: "100%",
    loading: false,
    emptyMessage: "No documents found",
    globalFilter: false,
    responsive: true
};
